import params$ from './params';
import thumbnailGenerator from '../thumbnailGenerator';
import createServiceObservables from './createServiceObservable';

const observables = createServiceObservables(
    'largeThumbs',
    params$,
    async (params) => {
        return {
            largeThumb: await thumbnailGenerator.generate(params.file, params.largeThumbSize, params.photo.signal),
            params,
        };
    },
    1,
);

const largeThumbErrors$ = observables.errorsOnly$;
const largeThumbs$ = observables.withoutErrors$;

export { largeThumbErrors$ };
export default largeThumbs$;
